import { takeEvery, call, put } from 'redux-saga/effects';
import { findClubs, getClub } from './api';

import {
  receiveClub,
  receiveClubs,
  REQUEST_CLUB,
  REQUEST_CLUBS,
  receiveSearchClubs,
  receiveAdvancedSearchClubs,
  REQUEST_SEARCH_CLUBS,
  REQUEST_ADVANCED_SEARCH_CLUBS
} from './actions';

function* callFindclub({ payload }) {
  const club = yield call(getClub, payload);
  yield put(receiveClub(club));
}

function* callAllClubs({ payload }) {
  const allClubs = yield call(findClubs, payload);
  yield put(receiveClubs(allClubs.data));
}

function* callSearchClubs({ payload }) {
  const allClubs = yield call(findClubs, payload);
  yield put(receiveSearchClubs(allClubs.data));
}

function* callAdvancedSearchClubs({ payload }) {
  const allClubs = yield call(findClubs, payload);
  yield put(receiveAdvancedSearchClubs(allClubs));
}

export function* clubSaga() {
  yield takeEvery(REQUEST_CLUB, callFindclub);
}

export function* clubsSaga() {
  yield takeEvery(REQUEST_CLUBS, callAllClubs);
}

export function* searchClubsSaga() {
  yield takeEvery(REQUEST_SEARCH_CLUBS, callSearchClubs);
}

export function* advancedSearchClubsSaga() {
  yield takeEvery(REQUEST_ADVANCED_SEARCH_CLUBS, callAdvancedSearchClubs);
}



// WEBPACK FOOTER //
// ./src/modules/club/sagas.js